import { Button, DialogBox, DialogBoxActions } from "@/_component/Common";
import { LAPTOP_MOCKUP_IMG, NO_IMAGE } from "@/_constant";
import { useLanguageContext } from "@/hooks";
import { renderHeading, renderPrice, renderSubtitle, renderTitle } from "@/utility";

export default function ListingAddonPlanConfirmationPopup({ onClose, onExplorePlan, onContinuePost, listingDetails }) {
    const { language } = useLanguageContext();

    return (
        <DialogBox title={language("label.need_add_on_plan")} onClose={onClose}>

            {/* ── Property card ── */}
            {listingDetails && (
                <div className="d-flex gap-3 pb-3 mb-3 border-bottom">
                    <div className="flex-shrink-0">
                        <img
                            src={listingDetails?.thumbnailUrl || NO_IMAGE}
                            alt="listing"
                            className="rounded"
                            style={{ width: "5.5rem", height: "5.5rem", objectFit: "cover" }}
                        />
                    </div>
                    <div className="d-flex flex-column justify-content-center gap-1">
                        <span className="fw-bold kg-purple" style={{ fontSize: "0.88rem" }}>
                            {renderPrice(listingDetails)}
                        </span>
                        <span className="fw-bold" style={{ fontSize: "0.97rem" }}>
                            {renderTitle(listingDetails)}
                        </span>
                        <span className="text-muted" style={{ fontSize: "0.82rem" }}>
                            {renderHeading(listingDetails)}
                        </span>
                        {renderSubtitle(listingDetails) && (
                            <span className="d-flex align-items-center gap-1 text-muted" style={{ fontSize: "0.82rem" }}>
                                <i className="bi bi-person-circle" style={{ fontSize: "0.88rem" }}></i>
                                {renderSubtitle(listingDetails)}
                            </span>
                        )}
                    </div>
                </div>
            )}

            {/* ── Promo banner section ── */}
            <div
                className="rounded-3 p-4 text-center"
                style={{ background: "linear-gradient(135deg, #f0eaff 0%, #e8dfff 100%)" }}
            >
                <p className="fw-bold fst-italic mb-1 kg-purple" style={{ fontSize: "1rem" }}>
                    &ldquo;{language("label.enhance_the_visibility_of_your_postings")}&rdquo;
                </p>
                <p className="mb-3" style={{ color: "#7c57b8", fontSize: "0.84rem" }}>
                    {language("label.your_posts_will_appear_in_our_deal_banners") ||
                        language("label.on_great_deal_banners_and_in_search_result")}
                </p>
                <img
                    src={LAPTOP_MOCKUP_IMG}
                    className="img-fluid"
                    alt="App preview on laptop"
                    style={{
                        maxHeight: "13rem",
                        display: "block",
                        margin: "0 auto",
                        border: "none",
                        outline: "none",
                    }}
                />
            </div>

            {/* ── Actions — link left, purple solid button right ── */}
            <div className="d-flex justify-content-between align-items-center mt-4">
                <button
                    type="button"
                    className="btn btn-link text-decoration-none fw-semibold p-0 kg-purple"
                    onClick={() => onContinuePost()}
                >
                    {language("label.continue_to_post")}
                </button>
                <Button purple solid onClick={() => onExplorePlan()}>
                    {language("label.explore_plans")}
                    <i className="bi bi-chevron-right ms-1"></i>
                </Button>
            </div>

        </DialogBox>
    );
}